export default {
  init() {
    // JavaScript to be fired on all pages

    $('.select2-single').each( function() {
      $(this).select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        dropdownPosition: 'below',
        dropdownParent: $(this).parent(),
      })
    })

    $('.select2-stage').each( function() {
      $(this).select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        dropdownPosition: 'below',
        dropdownParent: $(this).parent(),
        placeholder: 'Select stage of your product',
        templateResult: function (state) {
          if (!state.id) return state.text

          return $('<span class="checkbox"></span><span>'+state.text+'</span>');
        },
      })
    })
  },
  finalize() {
    // Only run on mobile
    function checkMedia(media) {
        if (media.matches) {
            $('.mobile-slick-slider').slick({
                arrows: false,
                dots: true,
            });
            $('.mobile-slick-slider-three-slides').slick({
                arrows: false,
                dots: true,
                slidesToShow: 3,
                slidesToScroll: 3,
            });
        }
    }

    var m = window.matchMedia('(max-width: 992px)');
    checkMedia(m); // Call listener function at run time
    m.addListener(checkMedia);


    $('.hamburger').click(function () {
      $(this).not('.is-static').toggleClass('is-active')
      if ($(this).parents('.navbar').length) {
        $('.navbar').toggleClass('is-active')
        $('body').toggleClass('navbar-active')
      }
    })

    $('a[href="#site-header"]').click((event) => {
      event.preventDefault()
      $('html, body').scrollTop($(event.target.hash).offset().top)
    })

    var myCollapsible = document.getElementById('primary-navigation')
    myCollapsible.addEventListener('shown.bs.collapse', function () {
      $( 'body' ).addClass( 'locked' );
    })
    myCollapsible.addEventListener('hidden.bs.collapse', function () {
      $( 'body' ).removeClass( 'locked' );
    })

    var dropdownElementList = [].slice.call(document.querySelectorAll('.nav-link-toggle'))
    dropdownElementList.map(function (dropdownMenu) {
      dropdownMenu.addEventListener('show.bs.dropdown', function () {
        $(this).parent().addClass('dropdown-active')
      })
      dropdownMenu.addEventListener('hide.bs.dropdown', function () {
        $(this).parent().removeClass('dropdown-active')
      })
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js